import fetch from 'node-fetch';
import Auth from '../Auth/Auth';
import * as ActionTypes from '../constants/ActionTypes';

const currentServerURL = process.env.REACT_APP_serverURL;
const auth = new Auth();

export function searchBooking(criteria) {
  return (dispatch) => {
    const endpoint = `${currentServerURL}/Bookings/GetBookingSummary`;
    const body = {
      "Criteria": criteria
    }

		dispatch({
			type: ActionTypes.SEARCH_BOOKING_REQUEST,
      body: body
		})

    fetch(endpoint, {
			method: 'POST',
      body: JSON.stringify(body),
			headers: {
				Authorization: 'Bearer ' + auth.getAccessToken(),
				'Content-Type': 'application/json',
        'Accept-Encoding': 'zip, deflate, br'
			}
		})
			.then(response => response.json())
			.then((result) => {
        if (result.status === "Success") {
          dispatch({
            type: ActionTypes.SEARCH_BOOKING_SUCCESS,
            payload: result,
            criteria: criteria
          })
        } else{
          dispatch({
  					type: ActionTypes.SEARCH_BOOKING_FAILURE,
  					payload: result,
            msg: `Search booking failed. <b>${result.message}</b>`
  				})
        }
			})
			.catch((error) => {
				console.log('searchBooking error: ', error)
				dispatch({
					type: ActionTypes.SEARCH_BOOKING_FAILURE,
					error,
					payload: null,
          msg: `Search booking failed. API issue.`
				})
			});
	};
}

export function changePage(val) {
  return (dispatch) => {
		dispatch({
			type: ActionTypes.CHANGE_PAGE,
      payload: val
		})
	};
}

export function clearBookingSearchResult() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.CLEAR_BOOKING_SEARCH_RESULT
    })
  }
}
